import { IButtonCategory } from "@interfaces/Shared/buttonCategory";
import { ReactElement } from "react";
import { UncontrolledTooltip } from "reactstrap";

interface IButtonContent {
  uuid: string;
  category: IButtonCategory;
}

const ButtonContent = ({ uuid, category }: IButtonContent): ReactElement => (
  <>
    <span className={category.spanClass} />
    <UncontrolledTooltip
      modifiers={{ preventOverflow: { boundariesElement: "window" } }}
      placement="top"
      target={`${category.tooltipTarget}${uuid}`}
    >
      {category.tooltipText}
    </UncontrolledTooltip>
  </>
);

export default ButtonContent;
